import * as types from '../constants/ActionTypes'

export function selectNetworkType(payload) {
  return { type: types.SET_NETWORK_TYPE, payload }
}
